import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AnimatePresence } from '@ubisend/framer-motion';
import {
  Flex,
  Button,
  Accordion,
  Explainer,
  Span,
  InlineNotification,
  Label,
  TextInput
} from '@ubisend/pulse-components';

import FormGroup from './FormGroup';
import SettingContainer from './SettingContainer';
import { exportTranscript } from '../../api/index';
import { isValidEmail } from '../../utilities/index';
import { useMutation, useTheme } from '../../hooks/index';
import getErrorMessage from './errors';

const RequestTranscript = () => {
  const [email, setEmail] = useState('');

  const [showEmailError, setShowEmailError] = useState(false);

  const theme = useTheme();

  const { t } = useTranslation('bots');

  const mutation = useMutation({
    mutationFn: exportTranscript,
    onSuccess: () => {
      setEmail('');
    }
  });

  const handleEmailChange = event => {
    setEmail(event.target.value);
  };

  const valid = Boolean(mutation.isEnabled && !mutation.isPending && email);

  const handleSubmit = event => {
    event.preventDefault();
    setShowEmailError(false);

    if (!isValidEmail(email)) {
      return setShowEmailError(true);
    }

    if (valid) {
      mutation.mutate(email);
    }
  };

  return (
    <SettingContainer>
      <Accordion divider header={t('request_transcript_setting_header')}>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Explainer type="note" hideLabel>
              <Span tinyText colour="black">
                {t('request_transcript_setting_description')}
              </Span>
            </Explainer>
            <Flex col>
              <Label htmlFor="email" colour="black">
                {t('request_transcript_setting_email_label')}
              </Label>
              <TextInput
                id="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="example@email.com"
              />
            </Flex>
            <AnimatePresence>
              {mutation.isError && (
                <InlineNotification
                  description={t(getErrorMessage(mutation.error))}
                  type="error"
                />
              )}
              {showEmailError && (
                <InlineNotification
                  description={t(
                    'request_transcript_setting_invalid_email_error_message'
                  )}
                  type="error"
                />
              )}
            </AnimatePresence>
            <AnimatePresence>
              {mutation.isSuccess && (
                <InlineNotification
                  description={t('request_transcript_setting_success_message')}
                  type="success"
                />
              )}
            </AnimatePresence>
            <Button
              icon="download"
              disabled={!valid}
              type="submit"
              customTextColour={theme.sentMessage?.text || 'white'}>
              {t('request_transcript_setting_submit_button')}
            </Button>
          </FormGroup>
        </form>
      </Accordion>
    </SettingContainer>
  );
};

export default RequestTranscript;
